import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  dark?: boolean;
  id?: string;
};
export function SectionCTA({
  label,
  dark = false,
  id
}: SectionCTAProps) {
  return <div className="mt-12" data-id="element-312" data-mp="1lcl5za2yaceo">
      <CTAButton label={label} id={id} data-id="element-313" data-mp="1qbxxw98oi9o4" />
      <p className={`mt-4 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${dark ? 'text-brand-200' : 'text-brand-900/70'}`} data-id="element-314" data-mp="1qams63voarud">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-315" data-mp="1ge0blradqmy5" />
        Instant digital access · One-time payment of $27
      </p>
    </div>;
}